export default __webpack_public_path__ + "static/media/movilist.fe054ad3.jpg";